import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

import { sections } from '../../../../common/config';
import useScrollStore from '../../../../common/store/useScrollStore';

const getThreshold = () => sections.height.landing / 100 * window.innerHeight;

const useSwirlAnimation = (ref: React.RefObject<THREE.Group>) => {
  const threshold = useRef(getThreshold());

  useEffect(() => useScrollStore.subscribe(state => {
    if (-state.position <= threshold.current && ref.current) {
      gsap.to(ref.current.rotation, {
        duration: 0,
        y: state.position / 75
      });
    }
  }), [ref, threshold]);

  useEffect(() => {
    function handleResize() {
      threshold.current = getThreshold();
    }

    window.addEventListener("resize", handleResize);
    return () => { window.removeEventListener("resize", handleResize) }
  }, []);
}

export default useSwirlAnimation;